import React from "react";
import * as styles from "./ValueStreamsSidePanel.module.scss";
import { Panel } from "cprime-foundational-components";
import { Stack } from "@mui/material";

import Button from "../../Components/Common/CprimeButton";
interface ValueStreamSidePanelProps {
  open: boolean;
  onClose: () => void;
  BodyComponent: React.ReactNode;
  addApplicationHandler: Function;
  descriptionApp: string;
  appId: any;
}

const AddApplicationSidePanel: React.FC<ValueStreamSidePanelProps> = ({
  open,
  onClose,
  BodyComponent,
  addApplicationHandler,
  descriptionApp,
  appId,
}) => {
  const scssClass = styles as any;

  return (
    <>
      <Panel
        id="addApplicationSidePanel"
        className={scssClass.userGroupMainPanel}
        sx={{
          "& .MuiDrawer-root": { padding: "0" },
          "& .MuiPaper-root": {
            width: "fit-content",
            minWidth: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        open={open}
        title={"Add Application"}
        side="right"
        onClose={onClose}
        body={
          <>
            {BodyComponent}
            <Stack
              direction="row"
              justifyContent="flex-end"
              textAlign="right"
              p="1rem 1.5rem 0rem 0rem"
              boxSizing="border-box"
              className={scssClass.footerButtons}
            >
              <Stack direction="row" gap={2}>
                <Button variant="tertiary" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={!appId}
                  onClick={() => {
                    addApplicationHandler(descriptionApp, appId);
                  }}
                >
                  Add Application
                </Button>
              </Stack>
            </Stack>
          </>
        }
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </>
  );
};

export default AddApplicationSidePanel;
